import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { useGetPMS } from "../../../hooks/pms.hooks";

const { Option } = Select;

const PMSSelect = ({ value, onChange, ...otherProps }) => {
  const { data: pmsData, isLoading } = useGetPMS();
  return (
    <Select
      placeholder="PMS"
      showSearch
      loading={isLoading}
      optionFilterProp="children"
      onChange={onChange}
      value={value}
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      style={{ width: "100%" }}
      {...otherProps}
    >
      {pmsData !== undefined
        ? pmsData.map((pms) => (
            <Option key={pms._id} value={pms._id}>
              {pms.pms_name}
            </Option>
          ))
        : undefined}
    </Select>
  );
};

PMSSelect.defaultProps = {};

PMSSelect.propTypes = {};

export default PMSSelect;
